module.exports = __webpack_public_path__ + "img/banner.9a96a117.jpg";